Buyapowa.Helpers.StaticHeight = class StaticHeight {
  constructor(el) {
    this.el = el;
    this.el.css({
      "min-height": this.el.outerHeight()});
  }
};
